export default "__VITE_PUBLIC_ASSET__0f5758fc__"